import { Button, Grid2, Stack, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconUserPlus } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { professorsList } from "../services/professors";
import ProfessorTableComponent from "../components/ProfessorTableComponent";
import ProfessorRegister from "../components/ProfessorRegister";
import PageHeader from "../components/PageHeader";

const Professors = () => {
  const [open, setOpen] = useState(false);
  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      fullName: string;
      email: string;
      phone: string;
      createdAt: string | Date;
      status: string;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["professorsList"],
    queryFn: async () => await professorsList({}),
    initialData: [],
  });

  // const {
  //   data: dataIndicators,
  //   isLoading: isLoadingIndicators,
  //   isFetching: isFetchingIndicators,
  //   refetch: refetchIndicators,
  // }: {
  //   data: {
  //     allProfessors: number;
  //     professorsByMonth: number;
  //   };
  //   isLoading: boolean;
  //   isFetching: boolean;
  //   refetch: () => void;
  // } = useQuery({
  //   queryKey: ["professorsIndicators"],
  //   queryFn: async () =>
  //     await professorsIndicators({
  //       startDate: moment().startOf("month").toDate(),
  //       endDate: moment().endOf("month").toDate(),
  //     }),
  //   initialData: { allProfessors: 0, professorsByMonth: 0 },
  // });

  const refetchAll = () => {
    refetch();
    // refetchIndicators();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Professores"
          subtitle="Informações gerais dos professores."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconUserPlus size={18} />
                <Typography variant="body2">Cadastrar professor</Typography>
              </Button>
            </Stack>
          }
        />
        {/* 
        <Grid2 size={12}>
          <IndicatorsCard
            data={[
              {
                id: 1,
                title: "Total",
                value: dataIndicators?.allProfessors,
                icon: "icon_users",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              // {
              //   id: 2,
              //   title: "Novos no mês",
              //   value: dataIndicators?.professorsByMonth,
              //   icon: "icon_users",
              //   size: { xs: 12, sm: 6, lg: 3 },
              // },
            ]}
          />
        </Grid2> */}
        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 1,
                  }}
                >
                  {/* <IconButton
                    sx={{ backgroundColor: "primary.main", borderRadius: 2 }}
                  >
                    <IconAdjustmentsHorizontal />
                  </IconButton> */}
                </Stack>
              </Stack>
            </Grid2>
            <Grid2 size={12}>
              <ProfessorTableComponent
                data={data}
                refetch={() => refetchAll()}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <ProfessorRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Professors;
